// Import scripts

// Styles
// import '../sass/main.scss';

// Import asset images
// import './images';

// Import javascript
// import debounce from './helpers/debounce';

import swiperSettings from './partials/swiperSettings';
import sidebarTrigger from './partials/sidebarTrigger';
import directory from './partials/directory';
import loadMoreNews from './partials/loadMoreNews';
import customSelect from './partials/customSelect';
import alertBar from './partials/alertBar';
import loadMoreSearch from './partials/loadMoreSearch';
import loadVideo from './partials/loadVideo';
import programFinder from './partials/programFinder';
import databaseSearch from './partials/databaseSearch';
import mediaSearch from './partials/mediaSearch';
import violetteSearch from './partials/violetteSearch';
import ffSearch from './partials/ffSearch';
import newsEvents from './partials/newsEvents';
import socialFeed from './partials/socialFeed';
import gravityForms from './partials/gravityForms';
import primoSearch from './partials/primoSearch';
import libraryJournals from './partials/libraryJournals';
import toggleAllAccordions from './partials/toggleAllAccordions';
import newTabLinks from './partials/newTabLinks';

import './partials/siteMenu';

jQuery(document).ready(function () {
    swiperSettings(jQuery);
    sidebarTrigger(jQuery);
    directory(jQuery);
    loadMoreNews(jQuery);
    loadMoreSearch(jQuery);
    loadVideo(jQuery);
    customSelect(jQuery);
    alertBar(jQuery);
    programFinder(jQuery);
    databaseSearch(jQuery);
    mediaSearch(jQuery);
    violetteSearch(jQuery);
    ffSearch(jQuery);
    newsEvents(jQuery);
	socialFeed(jQuery);
	gravityForms(jQuery);
    primoSearch(jQuery);
    libraryJournals(jQuery);
    toggleAllAccordions(jQuery);
    newTabLinks(jQuery);
});